import { SvgIcon, SvgIconProps } from '@mui/material';

export const TrendingDownCircle = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="13" stroke="white" strokeWidth="2" />
        <path d="M21 19L15.4653 13.6657C14.717 12.9445 14.3429 12.584 13.8788 12.584C13.4148 12.5841 13.0407 12.9447 12.2927 13.6661L12.1131 13.8391C11.3644 14.5611 10.99 14.9221 10.5257 14.9219C10.0613 14.9217 9.6872 14.5605 8.939 13.838L6 11M21 19V14.9667M21 19H16.8134" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <circle cx="14" cy="14" r="13" stroke="white" strokeWidth="2" />
        <path d="M21 19L15.4653 13.6657C14.717 12.9445 14.3429 12.584 13.8788 12.584C13.4148 12.5841 13.0407 12.9447 12.2927 13.6661L12.1131 13.8391C11.3644 14.5611 10.99 14.9221 10.5257 14.9219C10.0613 14.9217 9.6872 14.5605 8.939 13.838L6 11M21 19V14.9667M21 19H16.8134" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
};
